import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("mf_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

let refreshInFlight = null;

async function refreshSession() {
  const refresh_token = localStorage.getItem("mf_refresh");
  if (!refresh_token) return null;
  if (!refreshInFlight) {
    refreshInFlight = axios
      .post(`${API}/auth/refresh`, { refresh_token })
      .then(({ data }) => {
        localStorage.setItem("mf_token", data.token);
        if (data.refresh_token) localStorage.setItem("mf_refresh", data.refresh_token);
        return data.token;
      })
      .catch(() => {
        localStorage.removeItem("mf_token");
        localStorage.removeItem("mf_refresh");
        return null;
      })
      .finally(() => {
        refreshInFlight = null;
      });
  }
  return refreshInFlight;
}

api.interceptors.response.use(
  (res) => res,
  async (err) => {
    const original = err.config;
    const status = err.response?.status;
    const url = String(original?.url || "");
    const isAuthCall = url.includes("/auth/refresh") || url.includes("/auth/login");

    if (status === 401 && original && !original._retried && !isAuthCall) {
      if (localStorage.getItem("mf_refresh")) {
        original._retried = true;
        const newToken = await refreshSession();
        if (newToken) {
          original.headers = original.headers || {};
          original.headers.Authorization = `Bearer ${newToken}`;
          return api(original);
        }
      }
      // no refresh token or refresh failed -> force logout
      localStorage.removeItem("mf_token");
      localStorage.removeItem("mf_refresh");
      if (window.location.pathname !== "/login") window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export function apiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
